import React, { useState, useEffect } from "react";
import { Button, Empty } from "antd";

import TimeSheetTable from "../TimeSheetTable";
import SubUserAddModal from "../SubUserAddModal";

import useMembersStore from "../../store/members.store";
import useSubUserStore from "../../store/subUserModal.store";
import { DatePicker, Space } from 'antd';


import "./timeSheet.scss";
import FilterTimeSheet from "../filterTimeSheet";
import TimeSheetTableSetup from "../TimeSheetTableSetup";
import useTeamTimeSheetStore from "../../store/teamtimesheet";
import LeavesConfig from "../LeavesConfig";


const timeSheetTitlesSetup = [
    "Select",
    "S. No.",
    "QH User ID",
    "Emp ID",
    "Name",
    "Role",
    "Project",
    "Time Sheet Approvar",
    "Leave Approvar"
];

const timeSheetTitlesLeaves = [
    "Select",
    "S. No.",
    "QH User ID",
    "Emp ID",
    "Name",
    "Role",
    "Project",
    "Presence Status", //online, away, not loggin
    "Total Leaves", 
    "Leave Type",
    "Start Date",
    "End Date", 
    "Approval Status", //Accept, Reject, Pending
    "Approval Date",
    "Leave Req Date",
    "Comments"
];

const timeSheetTitlesDaily = [
    "Select",
    "S. No.",
    "QH User ID",
    "Emp ID",
    "Name",
    "Role",
    "Project",
    "Presence Status", //online, away, not loggin
    "Attendance Status", //online, away, not loggin
    "In Time",
    "Out Time",
    "Leave Status", //attendent_status = on_leave, absent, present
    "Total Hrs", //total hrs
    "Extra Hrs",    
    "Comments"
];

//need to select month
const timeSheetTitlesMonthly = [
    "Select",
    "S. No.",
    "Date",
    "Day",
    "Attendance Status",
    "In time",
    "Out Time",
    "Total Hrs",    
    "Extra Hrs",
    "Leave Type",
    "Comments",
];
const timeSheetTitlesMonthlyAggr = [
    "Select",
    "S. No.",
    "Emp ID",
    "Name",
    "Role",    
    "Total Hrs",    
    "Extra Hrs",
    "Num Leaves",
    "Comments",
];
const timeSheetTitlesYearlyAggr = [
    "Select",
    "S. No.",
    "Emp ID",
    "Name",
    "Role",  
    "Total Hrs",    
    "Extra Hrs",
    "Num Leaves",
    "Comments",
];
//need to select year
const timeSheetTitlesYearly = [
    "Select",
    "S. No.",
    "Month",
    "Total Hrs",    
    "Extra Hrs",
    "Num Leaves",
    "Comments",
];

//Select Month
const timeSheetTitlesInvoicing = [
    "Select",    
    "S. No.",
    "QH User ID",
    "Emp ID",
    "Name",
    "Role",
    "Project",
    "Period",
    "Total Hrs",
    "Rate ($)",
    "Rate (INR)",
    "Amount (Without Tax)",
    "Comments",
    "Action"
];

//need to select year
const leavesConfigs = [
    "Select",
    "S. No.",
    "Group/BU Name",
    "Config Id",
    "Config Name",
    "Year",
    "Holidays",
    "Leaves",
    "Saturday Status",
    "Date Updated",
];


function TimeSheet() {
    
    const [currentView, setCurrentView] = useState("setup");
    const [configView, setConfigView] = useState("existingconfig");
    const [selectedConfigID, setSelectedConfigViewID] = useState(0);

    const { getTeamMembers, teamMembers,timeSheetApprovarList ,leaveApprovarList} =
        useMembersStore();

    const { getTeamLeavesApplicationsList,teamLeavesApplicationList,getLeavesConfigList,
        leavesConfigList,updateLeaveConfigListFlag,resetLeaveConfigListFlag,getTeamsYearlyAttendance,
        getTeamsMonthlyAttendance,monthlyAttendance,yearlyAttendance,getTeamsMonthlyAttendanceAggregate,
        monthlyAttendanceAggregate,getTeamsYearlyAttendanceAggregate,yearlyAttendanceAggregate } =
        useTeamTimeSheetStore();       

    const { setModalOpen, setCurrentMemberType, removeMember } =
        useSubUserStore();

    const today =  new Date();
    const month = today.getMonth();
    const year = today.getFullYear();
    const date = today. getDate();        

    useEffect(() => {
        getTeamMembers();
        getTeamLeavesApplicationsList();
        getLeavesConfigList()
    }, []);
    
    useEffect(() => {
        if(updateLeaveConfigListFlag){
            getLeavesConfigList()
            resetLeaveConfigListFlag()
        }
    }, [updateLeaveConfigListFlag]);

    const getApprovarAssignement =(member) =>{
        if(member?.timesheetapprovarname != ""){
            return member.timesheetapprovarname
        }else{
            return "Please Assign"
        }
    }
    const getLeaveApprovarAssignement =(member) =>{
        if(member?.leaveapprovarname != ""){
            return member.leaveapprovarname
        }else{
            return "Please Assign"
        }
    }    
    
    const setupData = teamMembers?.map((member, idx) => {
        return {
            select:"",
            id:idx+1,
            qhuid: member.qhuid,
            empid: member.emd_id,
            name:member.username,
            designation:member.designation,
            project:member.project,
            tsapprovarname: getApprovarAssignement(member),
            leaveapprovarname:getLeaveApprovarAssignement(member),
        };
    }); 

    const leaveAppData = teamLeavesApplicationList?.map((member, idx) => {
        return {
            select:"",
            id:idx+1,
            qhuid: member.req.qhuid,
            empid: member.emd_id,
            name:member.req.username,
            designation:member.designation,
            project:member.project,
            presencestatus:member.presencestatus,
            totalleaves:member.req?.numleavesfulldays + 0.5 * member.req?.numleaveshalfdays, //IN, OUT,ABSENT,ON_LEAVE
            leavestype:member.req?.leavetype +"#"+ member.qhlid,//NO LEAVE,SICK_LEAVE,HOLIDAY, EL,LOP
            startdate:member.req?.leavestartdate,
            enddate:member.req?.leaveenddate,
            approvalstatus:member.leaveapprovalstatus, 
            approvaldate:member?.leaveapprovaldate,
            applicationdate:member.req?.leaveapplicationdate,
            comments: "" 
        };
    });

    const leaveConfigData = leavesConfigList?.map((member, idx) => {
        return {
            select:"",
            id:idx+1,
            groupname: member.groupname,
            leaveconfigid: member.qhlconfigid,
            leaveconfigname: member.name,
            year:member.year,
            totalholidays:member.totalholidays,
            totalleaves:member.totalleaves,
            saturday:member.saturdaymode,
            date:member.updatedby.updatedon,
        };
    });

    
    const dailyData = teamMembers?.map((member, idx) => {
        return {
            select:"",
            id:idx+1,
            qhuid: member.qhuid,
            empid: member.emd_id,
            name:member.username,
            designation:member.designation,
            project:member.project,
            presencestatus:member.presencestatus,
            attaendancestatus:member.todaystimesheetdetails?.attendancestatus, //IN, OUT,ABSENT,ON_LEAVE
            intime:member.todaystimesheetdetails?.intime,
            outtime:member.todaystimesheetdetails?.outtime,
            leavestatus:member.todaystimesheetdetails?.leavestatus, //NO LEAVE,SICK_LEAVE,HOLIDAY, EL,LOP
            totalhrs:member.todaystimesheetdetails?.workhrs,
            extrahrs:member.todaystimesheetdetails?.extrahrs,
            comments: "" 
        };
    });   

    const monthlyData = monthlyAttendance?.timesheet?.map((member, idx) => {
        return {
            select:"",
            id:idx+1,        
            date: member.date.currentdatestr,
            day: member.date.currentday,
            attaendancestatus:member?.attendancestatus, //IN, OUT,ABSENT,ON_LEAVE
            intime:member.date?.intime,
            outtime:member.date?.outtime,
            leavestatus:member?.leavetype, //NO LEAVE,SICK_LEAVE,HOLIDAY, EL,LOP
            totalhrs:member?.workhrs,
            extrahrs:member?.extrahrs,
            comments: "" 
        };
    });  

    const monthlyDataAggr = monthlyAttendanceAggregate?.map((member, idx) => {
        return {
            select:"",
            id:idx+1,        
            empid: member.empid,
            name: member.username,
            role:  member?.designation, //IN, OUT,ABSENT,ON_LEAVE
            totalhrs:member?.agrtimesheet.workhrs + member?.agrtimesheet.workmins,
            extrahrs:member?.agrtimesheet.extrahrs + member?.agrtimesheet.extramins,
            numLeaves:  member?.numleaves,
            comments: "" 
        };
    });     

    
    const yealyDataAggr = yearlyAttendanceAggregate?.map((member, idx) => {
        return {
            select:"",
            id:idx+1,        
            empid: member.empid,
            name: member.username,
            role:  member?.designation, //IN, OUT,ABSENT,ON_LEAVE
            totalhrs:member?.agrtimesheet.workhrs + member?.agrtimesheet.workmins,
            extrahrs:member?.agrtimesheet.extrahrs + member?.agrtimesheet.extramins,
            numLeaves:  member?.numleaves,
            comments: "" 
        };
    }); 

    const yearlyData = yearlyAttendance?.timesheet?.map((member, idx) => {
        return {
            select:"",
            id:idx+1,        
            month: member.date.currentmonth,
            totalhrs:member?.workhrs,
            extrahrs:member?.extrahrs,
            numLeaves:yearlyAttendance?.numleaves[idx],             
            comments: "" 
        };
    });         
    

    
    const teamMembersList =
        teamMembers && teamMembers.length > 0
            ? teamMembers.map((member, idx) => ({
                  id: idx + 1,
                  username: member?.username,
                  contact: member?.contact,
                  email: member?.email,
                  remove: (
                      <div
                          style={{
                              cursor: "pointer",
                              color: "blue",
                              fontWeight: "600",
                          }}
                          onClick={() => removeMember(member.ID)}
                      >
                          Remove
                      </div>
                  ),
                  admin: `${member?.admin}`,
              }))
            : [];


    const handleAddTeamClick = () => {
        setModalOpen();
        setCurrentMemberType("team");
    };

    const handleConfigView = (value) => {
        setConfigView(value)
    };

    const handleConfigViewCallback = (value, id) => {
        setConfigView(value)
        if(id != -1)
          setSelectedConfigViewID(id)
    };

    const getSelectedLeavesConfig = (leavesConfigList,selectedConfigID) => {
        for(let idx = 0; idx < leavesConfigList?.length; idx++){            
            if(leavesConfigList?.[idx]?.qhlconfigid == selectedConfigID){
                 return leavesConfigList[idx]
            }
        }
        return null
    }
    const getSelectedLeavesConfigName = (leavesConfigList,selectedConfigID) => {
        for(let idx = 0; idx < leavesConfigList?.length; idx++){            
            if(leavesConfigList?.[idx]?.qhlconfigid == selectedConfigID){
                 return leavesConfigList[idx].name
            }
        }
        return null
    }

    return (
        <div className="timesheet-container">
            <div className="timesheet-btns-wrapper">
                <Button
                    onClick={() => setCurrentView("setup")}
                    className={`timesheet-btn ${
                        currentView === "setup" && "timesheet-btn-active"
                    }`}
                >
                    Employees Setup
                </Button>                  
                <Button
                    onClick={() => setCurrentView("monthly")}
                    className={`timesheet-btn ${
                        currentView === "monthly" && "timesheet-btn-active"
                    }`}
                >
                   Monthly/User
                </Button>                
                <Button
                    onClick={() => setCurrentView("yearly")}
                    className={`timesheet-btn ${
                        currentView === "yearly" && "timesheet-btn-active"
                    }`}
                >
                    Yearly/User
                </Button>
                                <Button
                    onClick={() => setCurrentView("monthlyteam")}
                    className={`timesheet-btn ${
                        currentView === "monthlyteam" && "timesheet-btn-active"
                    }`}
                >
                   Monthly/Team
                </Button>                
                <Button
                    onClick={() => setCurrentView("yearlyteam")}
                    className={`timesheet-btn ${
                        currentView === "yearlyteam" && "timesheet-btn-active"
                    }`}
                >
                    Yearly/Team
                </Button>
                <Button
                    onClick={() => setCurrentView("invoicing")}
                    className={`timesheet-btn ${
                        currentView === "invoicing" && "timesheet-btn-active"
                    }`}
                >
                    Invoicing
                </Button> 
                <Button
                    onClick={() => setCurrentView("leaves")}
                    className={`timesheet-btn ${
                        currentView === "leaves" && "timesheet-btn-active"
                    }`}
                >
                    Leave Approvals
                </Button>  
                <Button
                    onClick={() => setCurrentView("leavesconfig")}
                    className={`timesheet-btn ${
                        currentView === "leavesconfig" && "timesheet-btn-active"
                    }`}
                >
                    Leave Configurations
                </Button>                                                                                             
            </div>
            <div className="timesheet-members-wrapper">
                  {currentView === "leaves" ? (
                      <div className="timesheet-members-title" >
                        <h4 className="timesheet-members-list-title">Leaves Mgmt for Team</h4>
                        <FilterTimeSheet
                                filtername = {"getAllJdsInternalConsolidatedStats"}
                                initDuration={"24"}
                                initPrio={"All"}
                                initResume={"All"}
                                initJDStatus={"Active"}    
                                enableDuration
                                enableResumes
                                enablePriority
                                enableJdStatus
                                enableCustomers      
                                handleFilter={null}
                        />     
                        <div className="timesheet-members-table">
                        {teamLeavesApplicationList?.length > 0 ? (
                                <TimeSheetTable
                                    titleList={timeSheetTitlesLeaves}
                                    currentView = {currentView}
                                    data={leaveAppData}
                                    config = {`50px 1fr 1fr 2fr 1fr repeat(${timeSheetTitlesLeaves.length-5}, 1fr)`}
                                />
                            ) : (
                                <Empty style={{ margin: "60px" }} />
                        )}
                         </div>   
                    </div>   
                    ): <></>
                  } 
                  {currentView === "leavesconfig" ? (
                      <div className="timesheet-members-title" >
                        <h4 className="timesheet-members-list-title">Leaves Configuration</h4>   
                        {
                            configView =="newconfig"?
                            <>
                                <div className="timesheet-leave-members-row ">
                                     <div className="timesheet-leave-members-row-item">
                                            Create New Configuration                                   
                                     </div>                                       
                                     <div className="timesheet-leave-members-row-item">
                                        <Button
                                                onClick={()=>handleConfigView("existingconfig")}
                                                className="timesheet-member-select-period"
                                        >
                                                Cancel
                                        </Button>                                     
                                     </div>                                  
                                </div> 

                                <div className="timesheet-members-table">
                                    <LeavesConfig  exist = {false} configData={null} configViewHandler = {handleConfigViewCallback}/>
                                </div>                            
                            </>
                            :configView =="existingconfig"?<>
                                <div className="timesheet-leave-members-row ">
                                     <div className="timesheet-leave-members-row-item">
                                        <Button
                                                onClick={()=>handleConfigView("newconfig")}
                                                className="timesheet-member-select-period"
                                        >
                                                + Add New Configuration
                                        </Button>                                       
                                     </div>
                                </div>                         
                                {leavesConfigList?.length > 0 ? (
                                        <TimeSheetTable
                                            titleList={leavesConfigs}
                                            data={leaveConfigData}
                                            currentView = {currentView}
                                            configViewHandler = {handleConfigViewCallback}
                                            config = {`50px 1fr 1fr 2fr 1fr repeat(${leavesConfigs.length-5}, 1fr)`}
                                        />
                                    ) : (
                                        <Empty style={{ margin: "60px" }} />
                                )}                            
                            </>
                            :configView =="updateconfig"?<>
                                <div className="timesheet-leave-members-row ">
                                     <div className="timesheet-leave-members-row-item">
                                            Update Configuration {" - "+ getSelectedLeavesConfigName(leavesConfigList,selectedConfigID)}                               
                                     </div>                                       
                                     <div className="timesheet-leave-members-row-item">
                                        <Button
                                                onClick={()=>handleConfigView("existingconfig")}
                                                className="timesheet-member-select-period"
                                        >
                                            Cancel
                                        </Button>                                     
                                     </div>                                  
                                </div> 

                                <div className="timesheet-members-table">
                                    <LeavesConfig  exist = {true} 
                                                   configData={getSelectedLeavesConfig(leavesConfigList, selectedConfigID)}
                                                   configViewHandler = {handleConfigViewCallback}/>
                                </div>                               
                            </>
                            :<></>
                        }                        
   
                    </div>   
                    ): <></>
                  }                                   
                  {currentView === "daily" ? (
                      <div className="timesheet-members-title" >
                        <h4 className="timesheet-members-list-title">Daily Time for Team -Select User/Project</h4>
                              <FilterTimeSheet
                                filtername = {"getAllJdsInternalConsolidatedStats"}
                                initProject={"Please Select"}
                                initYear={year}
                                initMonth={month}
                                initUsers={"Please Select"}  
                                enableProject
                                enableUsers
                                enableMonths
                                enableYear   
                                handleFilter={null}
                              />
                        <div className="timesheet-members-table">
                        {teamMembers?.length > 0 ? (
                                <TimeSheetTable
                                    titleList={timeSheetTitlesDaily}
                                    currentView = {currentView}
                                    data={dailyData}
                                    config = {`50px 1fr 1fr 2fr 1fr repeat(${timeSheetTitlesDaily.length-5}, 1fr)`}
                                />
                            ) : (
                                <Empty style={{ margin: "60px" }} />
                        )}
                         </div>   
                    </div>   
                    ): <></>
                  }
                  {currentView === "monthly" ? (
                      <div className="timesheet-members-title" >
                        <h4 className="timesheet-members-list-title">Monthly Timesheet for Teammember</h4>
                              <FilterTimeSheet
                                filtername = {"getTeamsMonthlyAttendance"}
                                initProject={"Please Select"}
                                initMonth={month}
                                initYear={year}
                                initUsers={"Please Select"}
                                enableProject
                                enableUsers
                                enableYear   
                                enableMonths
                                handleFilter={getTeamsMonthlyAttendance}
                              />  
                        <div className="timesheet-members-table">
                        {monthlyAttendance?.timesheet?.length > 0 ? (
                                <TimeSheetTable
                                    titleList={timeSheetTitlesMonthly}
                                    data={monthlyData}
                                    config = {`50px 1fr 1fr 2fr 1fr repeat(${timeSheetTitlesMonthly.length-5}, 1fr)`}
                                />
                            ) : (
                                <Empty style={{ margin: "60px" }} />
                        )}
                         </div>   
                    </div>   
                    ): <></>
                  }
                  {currentView === "yearly" ? (
                      <div className="timesheet-members-title" >
                        <h4 className="timesheet-members-list-title">Yearly Timesheet for Teammember</h4>
                              <FilterTimeSheet
                                filtername = {"getTeamsYearlyAttendance"}
                                initProject={"Please Select"}
                                initYear={year}
                                initUsers={"Please Select"}
                                enableProject
                                enableUsers
                                enableYear   
                                handleFilter={getTeamsYearlyAttendance}
                              />    
                        <div className="timesheet-members-table">
                        {yearlyAttendance?.timesheet?.length > 0 ? (
                                <TimeSheetTable
                                    titleList={timeSheetTitlesYearly}
                                    data={yearlyData}
                                    config = {`50px 1fr 1fr 2fr 1fr repeat(${timeSheetTitlesYearly.length-5}, 1fr)`}
                                />
                            ) : (
                                <Empty style={{ margin: "60px" }} />
                        )}
                         </div>   
                    </div>   
                    ): <></>
                  } 
                  {currentView === "monthlyteam" ? (
                      <div className="timesheet-members-title" >
                        <h4 className="timesheet-members-list-title">Monthly Timesheet for Teammember</h4>
                              <FilterTimeSheet
                                filtername = {"getTeamsMonthlyAttendanceAggregate"}
                                initProject={"Please Select"}
                                initMonth={month}
                                initYear={year}
                                enableProject
                                enableYear   
                                enableMonths
                                handleFilter={getTeamsMonthlyAttendanceAggregate}
                              />  
                        <div className="timesheet-members-table">
                        {monthlyAttendanceAggregate?.length > 0 ? (
                                <TimeSheetTable
                                    titleList={timeSheetTitlesMonthlyAggr}
                                    data={monthlyDataAggr}
                                    config = {`50px 1fr 1fr 2fr 1fr repeat(${timeSheetTitlesMonthlyAggr.length-5}, 1fr)`}
                                />
                            ) : (
                                <Empty style={{ margin: "60px" }} />
                        )}
                         </div>   
                    </div>   
                    ): <></>
                  } 
                  {currentView === "yearlyteam" ? (
                      <div className="timesheet-members-title" >
                        <h4 className="timesheet-members-list-title">Yearly Timesheet for Teammember</h4>
                              <FilterTimeSheet
                                filtername = {"getTeamsYearlyAttendanceAggregate"}
                                initProject={"Please Select"}
                                initYear={year}
                                enableProject
                                enableYear   
                                handleFilter={getTeamsYearlyAttendanceAggregate}
                              />  
                        <div className="timesheet-members-table">
                        {yearlyAttendanceAggregate?.length > 0 ? (
                                <TimeSheetTable
                                    titleList={timeSheetTitlesYearlyAggr}
                                    data={yealyDataAggr}
                                    config = {`50px 1fr 1fr 2fr 1fr repeat(${timeSheetTitlesYearlyAggr.length-5}, 1fr)`}
                                />
                            ) : (
                                <Empty style={{ margin: "60px" }} />
                        )}
                         </div>   
                    </div>   
                    ): <></>
                  }                                      
                  {currentView === "invoicing" ? (
                      <div className="timesheet-members-title" >
                        <h4 className="timesheet-members-list-title">Monthly Invoicing -Select Month/Project</h4>
                        <FilterTimeSheet
                                filtername = {"getAllJdsInternalConsolidatedStats"}
                                initDuration={"24"}
                                initPrio={"All"}
                                initResume={"All"}
                                initJDStatus={"Active"}    
                                enableDuration
                                enableResumes
                                enablePriority
                                enableJdStatus
                                enableCustomers      
                                handleFilter={null}
                        />     
                        <div className="timesheet-members-table">
                        {teamMembers?.length > 0 ? (
                                <TimeSheetTable
                                    titleList={timeSheetTitlesInvoicing}
                                    data={teamMembersList}
                                    config = {`50px 1fr 1fr 2fr 1fr repeat(${timeSheetTitlesInvoicing.length-5}, 1fr)`}
                                />
                            ) : (
                                <Empty style={{ margin: "60px" }} />
                        )}
                         </div>   
                    </div>   
                    ): <></>
                  }       
                  {currentView === "setup" ? (
                      <div className="timesheet-members-title" >   
                        <div className="timesheet-members-table">
                        {teamMembers?.length > 0 ? (
                                <TimeSheetTableSetup
                                    titleList={timeSheetTitlesSetup}
                                    currentView = {currentView}
                                    data={setupData}
                                    alist ={timeSheetApprovarList}
                                    llist ={leaveApprovarList}
                                    showList = {true}
                                    config = {`50px 1fr 1fr 2fr 1fr repeat(${timeSheetTitlesSetup.length-5}, 1fr)`}
 
                                />
                            ) : (
                                <Empty style={{ margin: "60px" }} />
                        )}
                         </div>   
                    </div>   
                    ): <></>
                  }                                                                                                
            </div>
            <SubUserAddModal />
        </div>
    );
}

export default TimeSheet;
